import { Module } from 'vuex';
import { getters } from './getters';
import { actions } from './actions';
import { mutations } from './mutations';
import { RootState } from '@/interface/store';
import { Inventory } from '@/interface/store/inventory';

export const initialState = () => {
  return {
    dataList: [],
    totalCount: 0,
    queryParams: {
      id: '',
      type: 'inventory',
      attributes: '',
      limit: 20,
      offset: 0,
      order: '-updatedAt',
      include: '',
      fkGroupId: '',
      fkUserId: '',
    },
    inventoryItem: {
      id: '',
      name: '',
      serialNumber: null,
      catalogNumber: null,
      unitSize: null,
      unit: '',
      quantity: 0,
      price: 0,
      ownedBy: '',
      url: null,
      casNumber: null,
      lotNumber: null,
      expiresOn: null,
      technicalDetails: null,
      boughtFrom: null,
      expirationReminder: '',
      customFields: [],
      vendorName: null,
      manufacturerName: null,
      isArchived: false,
      notes: null,
      createdBy: '',
      createdAt: '',
      updatedBy: '',
      updatedAt: '',
      lastReceivedAt: null,
      fkTypeId: '',
      fkVendorId: null,
      fkManufacturerId: null,
      fkLocationId: null,
      fkLocationSubId: null,
      fkType: { id: '', name: '', fkGroupId: '', prefix: '' },
      fkVendor: {
        id: '',
        name: '',
        url: null,
        contactName: null,
        contactPhone: null,
        contactEmail: null,
        info: null,
        fkGroupId: '',
      },
      fkManufacturer: {
        id: '',
        name: '',
        url: null,
        contactName: null,
        contactPhone: null,
        contactEmail: null,
        info: null,
        fkGroupId: '',
      },
      fkLocation: { id: '', name: '', fkGroupId: '' },
      fkLocationSub: {
        id: '',
        name: '',
        fkLocationId: '',
      },
      fkOwnedBy: {
        id: '',
        organization: null,
        email: '',
        firstName: null,
        lastName: null,
        fullName: '',
        position: null,
        phoneNumber: '',
        isEmailConfirmed: false,
        subscribedToNewsletters: false,
        emailSettings: {
          orderRequestUpdated: '',
          orderRequestAccepted: '',
        },
        settings: {
          recordsPerPage: 0,
          ordersBackupInterval: '',
          inventoryBackupInterval: '',
          receiveCommentNotifications: false,
        },
        lastGroupId: null,
      },
    },
    inventoryAttachments: [],
    inventoryHistories: [],
    inventoryFilter: {
      Locations: { mainArray: [], subArray: [] },
      Types: { subArray: [] },
      Users: { subArray: [] },
      Vendors: { subArray: [] },
      Manufacturers: { subArray: [] },
    },
    inventoryFilterStack: {
      Locations: [],
      Types: [],
      Users: [],
      Vendors: [],
      Manufacturers: [],
    },
  };
};

export const state: Inventory = initialState();

const namespaced: boolean = true;

export const inventory: Module<Inventory, RootState> = {
  namespaced,
  state,
  getters,
  actions,
  mutations,
};
